import React, { useState } from 'react';
import './ProfessionalEnrollment.css';

function ProfessionalEnrollment() {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="professional-enrollment">
      <div className="professional-enrollment-content">
        <h1 className="professional-enrollment-title">Professional Enrollment</h1>
        <p className="professional-enrollment-intro-text">
          Welcome to the <strong>Professional Enrollment</strong> program! Our goal is to connect you with the under-graduates and working professionals
          and help them with their career development by sharing your experience with them. Below, you will find details regarding the enrollment process.
        </p>

        <div className="professional-enrollment-details-section">
          <h2 className="professional-enrollment-section-title">Enrollment Details</h2>
          <ul className="professional-enrollment-details-list">
            <li className="professional-enrollment-detail-item">
              <span className="professional-enrollment-detail-label">Approval Needed:</span> You must be approved to participate.
            </li>
            <li className="professional-enrollment-detail-item">
              <span className="professional-enrollment-detail-label">Processing Time:</span> Enrollment may take up to <strong>2 days</strong>.
            </li>
            <li className="professional-enrollment-detail-item">
              <span className="professional-enrollment-detail-label">Required Documents:</span> Please upload the following documents:
              <ul className="professional-enrollment-documents-list">
                <li>Profile Picture (Clear and Decent Quality)</li>
                <li>Resume Document</li>
                <li>Proof of Identity (Aadhar, PAN, or Driving License)</li>
              </ul>
            </li>
          </ul>
        </div>

        <p className="professional-enrollment-enrollment-note">
          Once your documents are uploaded, you will be reviewed for approval. Please ensure all documents are clear and legible.
        </p>

        <div className="terms-container">
          <input
            type="checkbox"
            id="agreeTerms"
            className="terms-checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <label htmlFor="agreeTerms" className="terms-label">
            I agree to the
            <a href="/#/professional-enroll-terms-and-conditions" className="terms-link">Terms and Conditions</a>and
            <a href="/#/privacy-policy" className="terms-link"> Privacy Policy</a>.
          </label>
        </div>

        <a href="/#/professional-enrollment-form" className="professional-enrollment-enroll-now-button"
          style={{ pointerEvents: isChecked ? 'auto' : 'none', opacity: isChecked ? 1 : 0.5 }}>
          Enroll Now
        </a>
      </div>
    </div>
  );
}

export default ProfessionalEnrollment;
